<template>
  <article class="meal-list-article">
    <Stack
      :key="mealsNumber"
      v-if="mealsNumber > 0"
      :column-min-width="columnWidth"
      :gutter-height="15"
    >
      <StackItem
        v-for="(meal, index) in meals"
        :key="index"
        style="transition: transform 200ms"
      >
        <Meal
          :style="{ width: `${mealWidth}px` }"
          :meal="meal"
          :clickable="clickable"
          :updatable="updatable"
          @click="$emit('click', meal)"
        />
      </StackItem>
    </Stack>
    <p v-show="mealsNumber === 0">{{ emptyMsg }}</p>
  </article>
</template>

<script>
import _ from 'lodash';
import { Stack, StackItem } from 'vue-stack-grid';
import Meal from './Meal.vue';

export default {
  components: {
    Meal,
    Stack,
    StackItem,
  },
  props: {
    clickable: {
      type: Boolean,
      default: false,
    },
    updatable: {
      type: Boolean,
      default: false,
    },
    emptyMsg: {
      type: String,
      default: 'La liste est vide',
    },
    meals: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    mealsNumber() {
      // Permet de reload si on change 1 meal ou 1 ingrédient
      return this.meals.length + this.ingredientsNumber;
    },
    ingredientsNumber() {
      // On prend tous les ingrédients et on sum
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      return this.meals
        .map((meal) => _.get(meal, 'ingredients', []).length)
        .reduce(reducer, 0);
    },
    // StackItem
    mealWidth() {
      return this.isMediumScreen ? 150 : 200;
    },
    columnWidth() {
      // + pour les marges
      return this.mealWidth + 15;
    },
  },
};
</script>

<style lang="scss" scoped src="./MealList.scss"></style>
